import { useState } from 'react'
import './ShareBar.css'

interface Props {
  title: string
  text: string
  /** Prefer current view URL (includes ?view=lyrics when enabled). */
  shareUrl?: string
}

export function ShareBar({ title, text, shareUrl }: Props) {
  const [copied, setCopied] = useState<'lyrics' | 'link' | null>(null)
  const url =
    shareUrl ||
    (typeof window !== 'undefined' ? window.location.href : '')

  async function copy(kind: 'lyrics' | 'link', value: string) {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(kind)
      setTimeout(() => setCopied(null), 2000)
    } catch {
      /* ignore */
    }
  }

  const wa = `https://wa.me/?text=${encodeURIComponent(`${title}\n${url}`)}`
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`

  return (
    <div className="share-bar" role="group" aria-label="பகிர்வு கருவிகள்">
      <button type="button" className="share-bar__btn" onClick={() => copy('lyrics', text)}>
        {copied === 'lyrics' ? 'நகலெடுக்கப்பட்டது' : 'வரிகளை நகலெடு'}
      </button>
      <a className="share-bar__btn" href={wa} target="_blank" rel="noopener noreferrer">
        WhatsApp
      </a>
      <a className="share-bar__btn" href={fb} target="_blank" rel="noopener noreferrer">
        Facebook
      </a>
      <button type="button" className="share-bar__btn" onClick={() => copy('link', url)}>
        {copied === 'link' ? 'லிங்க் நகலெடுக்கப்பட்டது' : 'லிங்க் நகலெடு'}
      </button>
      <button type="button" className="share-bar__btn" onClick={() => window.print()}>
        அச்சிடு
      </button>
    </div>
  )
}

export function TextSizeControls({
  size,
  onChange,
}: {
  size: number
  onChange: (n: number) => void
}) {
  return (
    <div className="text-size" role="group" aria-label="எழுத்து அளவு">
      <button type="button" className="share-bar__btn" onClick={() => onChange(Math.max(0.9, size - 0.1))} aria-label="குறை">
        அ-
      </button>
      <span>எழுத்து அளவு</span>
      <button type="button" className="share-bar__btn" onClick={() => onChange(Math.min(1.45, size + 0.1))} aria-label="அதிகரி">
        அ+
      </button>
    </div>
  )
}
